// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Connectivity Test Component Styles */

.connectivity-test-container {
    background: var(--card-bg);
    backdrop-filter: var(--glass-blur);
    border: var(--glass-border) !important;
    border-radius: 32px;
    padding: 3rem;
    margin: 2rem 0;
    box-shadow: var(--glass-shadow), var(--glass-inner-glow);
}

.connectivity-test-header {
    text-align: center;
    margin-bottom: 3.5rem;
}

.connectivity-test-header h3 {
    font-size: 2.4rem;
    font-weight: 600;
    color: var(--text-main);
    letter-spacing: -0.03em;
    margin-bottom: 0.5rem;
}

.connectivity-test-header p {
    font-size: 1.1rem;
    color: var(--text-secondary);
    font-weight: 500;
}

/* Visual Flow Diagram */
.connectivity-flow {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2.5rem;
    margin: 4rem 0;
    padding: 3rem;
    background: rgba(15, 22, 42, 0.2);
    border-radius: 28px;
    border: var(--glass-border) !important;
    box-shadow: inset 0 2px 10px rgba(0, 0, 0, 0.3);
}

.flow-node {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    padding: 2.5rem;
    background: var(--card-bg) !important;
    backdrop-filter: var(--glass-blur);
    border: var(--glass-border) !important;
    border-radius: 24px;
    min-width: 180px;
    position: relative;
    transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
    box-shadow: var(--glass-shadow), var(--glass-inner-glow);
}

.flow-node:hover {
    transform: translateY(-6px) scale(1.025);
    box-shadow: 0 16px 36px rgba(99, 102, 241, 0.15), var(--glass-shadow);
    border-color: rgba(99, 102, 241, 0.3) !important;
}

.flow-node.active {
    transform: scale(1.05);
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);
    animation: pulse 2s infinite;
}

.flow-node.success {
    border: 3px solid #10b981;
}

.flow-node.error {
    border: 3px solid #ef4444;
}

@keyframes pulse {

    0%,
    100% {
        box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);
    }

    50% {
        box-shadow: 0 8px 32px rgba(102, 126, 234, 0.6);
    }
}

.flow-node .node-icon {
    font-size: 48px;
    margin-bottom: 8px;
}

.flow-node .node-label {
    font-size: 14px;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.flow-node .node-name {
    font-size: 16px;
    font-weight: 500;
    color: var(--text-primary);
    text-align: center;
}

.flow-node .node-status {
    position: absolute;
    top: -12px;
    right: -12px;
    font-size: 32px;
    background: var(--bg-button-secondary);
    border: var(--glass-border);
    border-radius: 50%;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: var(--glass-shadow);
}

.flow-arrow {
    display: flex;
    align-items: center;
    gap: 4px;
    color: rgba(255, 255, 255, 0.8);
}

.arrow-line {
    width: 60px;
    height: 3px;
    background: rgba(255, 255, 255, 0.6);
    border-radius: 2px;
}

.arrow-head {
    font-size: 32px;
    font-weight: bold;
}

/* Test Action */
.test-action {
    text-align: center;
    margin: 24px 0;
}

.btn-test-connectivity {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white;
    border: none;
    padding: 16px 48px;
    border-radius: 16px;
    font-size: 1.1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    box-shadow: 0 10px 30px rgba(16, 185, 129, 0.3), var(--glass-inner-glow);
}

.btn-test-connectivity:hover:not(:disabled) {
    transform: translateY(-3px) scale(1.02);
    box-shadow: 0 20px 45px rgba(16, 185, 129, 0.45), var(--glass-inner-glow);
}

.btn-test-connectivity:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Test Results */
.test-results-container {
    margin-top: 32px;
    background: var(--surface-light);
    border-radius: 12px;
    padding: 32px;
}

.overall-success,
.overall-error,
.overall-warning {
    text-align: center;
    padding: 32px;
    border-radius: 16px;
    margin-bottom: 24px;
    box-shadow: var(--glass-shadow), var(--glass-inner-glow);
    backdrop-filter: var(--glass-blur);
}

.overall-success {
    background: rgba(16, 185, 129, 0.06);
    border: 1.5px solid rgba(16, 185, 129, 0.3);
    color: #10b981;
}

.overall-error {
    background: rgba(239, 68, 68, 0.06);
    border: 1.5px solid rgba(239, 68, 68, 0.3);
    color: #ef4444;
}

.overall-warning {
    background: rgba(245, 158, 11, 0.06);
    border: 1.5px solid rgba(245, 158, 11, 0.3);
    color: #f59e0b;
}

.success-icon,
.error-icon,
.warning-icon {
    font-size: 64px;
    margin-bottom: 16px;
}

.overall-success h3 {
    color: #10b981;
    margin: 0 0 8px 0;
}

.overall-error h3 {
    color: #ef4444;
    margin: 0 0 8px 0;
}

.overall-warning h3 {
    color: #f59e0b;
    margin: 0 0 8px 0;
}

.overall-success p,
.overall-error p,
.overall-warning p {
    margin: 0;
    font-size: 16px;
    opacity: 0.95;
}

/* Connection Test Details */
.detailed-results {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.connection-test-details {
    background: var(--card-bg);
    border-radius: 12px;
    padding: 24px;
    border: 1px solid var(--card-border);
}

.test-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 2px solid var(--border-color);
}

.test-header h4 {
    margin: 0;
    font-size: 20px;
    color: var(--text-primary);
}

.connection-name {
    font-size: 14px;
    color: var(--text-muted);
    font-weight: 600;
}

.detail-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    margin-bottom: 16px;
}

.detail-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.detail-item.full-width {
    grid-column: 1 / -1;
}

.detail-label {
    font-size: 13px;
    color: #64748b;
    font-weight: 600;
}

.detail-value {
    font-size: 16px;
    color: var(--text-secondary);
    font-weight: 500;
}

.latency-value {
    font-size: 20px;
}

.version-text {
    font-size: 14px;
    font-family: 'Courier New', monospace;
    background: var(--bg-input);
    color: var(--text-primary);
    padding: 8px 12px;
    border-radius: 6px;
    border: var(--glass-border);
}

/* Capabilities */
.capabilities-section {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid var(--border-color);
}

.capabilities-section h5 {
    margin: 0 0 12px 0;
    font-size: 16px;
    color: #1e293b;
}

.capability-badges {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.capability-badge {
    padding: 6px 14px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    background: var(--surface-light);
    color: var(--text-secondary);
}

.capability-badge.cdc-supported {
    background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
    color: #1e40af;
}

.capability-badge.cdc-ready {
    background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
    color: #065f46;
}

.capability-badge.can-write {
    background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%);
    color: #9f1239;
}

/* Warnings and Errors */
.warnings-section,
.errors-section,
.suggestions-section {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid var(--border-color);
}

.warnings-section h5,
.errors-section h5,
.suggestions-section h5 {
    margin: 0 0 12px 0;
    font-size: 16px;
    color: #1e293b;
}

.warning-item,
.error-item,
.suggestion-item {
    padding: 12px 16px;
    border-radius: 8px;
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 1.6;
}

.warning-item {
    background: rgba(245, 158, 11, 0.05);
    border: 1px solid rgba(245, 158, 11, 0.15);
    border-left: 4px solid #f59e0b;
    color: #f59e0b;
}

.error-item {
    background: rgba(239, 68, 68, 0.05);
    border: 1px solid rgba(239, 68, 68, 0.15);
    border-left: 4px solid #ef4444;
    color: #ef4444;
}

.suggestion-item {
    background: rgba(59, 130, 246, 0.05);
    border: 1px solid rgba(59, 130, 246, 0.15);
    border-left: 4px solid #3b82f6;
    color: #3b82f6;
}

/* Bridge Recommendations */
.bridge-recommendations {
    background: linear-gradient(135deg, rgba(139, 92, 246, 0.08) 0%, rgba(99, 102, 241, 0.08) 100%);
    border-radius: 12px;
    padding: 24px;
    border: 1.5px solid rgba(139, 92, 246, 0.25);
    box-shadow: var(--glass-shadow);
}

.bridge-recommendations h4 {
    margin: 0 0 16px 0;
    font-size: 18px;
    color: var(--text-accent);
}

.recommendation-item {
    padding: 12px 16px;
    background: var(--card-bg);
    border: var(--glass-border);
    border-radius: 8px;
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 1.6;
    color: var(--text-primary);
    border-left: 4px solid #8b5cf6;
}

.recommendation-item:last-child {
    margin-bottom: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
    .connectivity-flow {
        flex-direction: column;
        gap: 16px;
    }

    .flow-arrow {
        transform: rotate(90deg);
    }

    .flow-node {
        width: 100%;
        max-width: 300px;
    }

    .detail-grid {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/dms/ConnectivityTest.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,sCAAsC;IACtC,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,wDAAwD;AAC5D;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,cAAc;IACd,aAAa;IACb,iCAAiC;IACjC,mBAAmB;IACnB,sCAAsC;IACtC,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,qCAAqC;IACrC,kCAAkC;IAClC,sCAAsC;IACtC,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mDAAmD;IACnD,wDAAwD;AAC5D;;AAEA;IACI,wCAAwC;IACxC,qEAAqE;IACrE,gDAAgD;AACpD;;AAEA;IACI,sBAAsB;IACtB,+CAA+C;IAC/C,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI;;QAEI,+CAA+C;IACnD;;IAEA;QACI,+CAA+C;IACnD;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,sCAAsC;IACtC,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kDAAkD;IAClD,wEAAwE;AAC5E;;AAEA;IACI,uCAAuC;IACvC,yEAAyE;AAC7E;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,aAAa;AACjB;;AAEA;;;IAGI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,wDAAwD;IACxD,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;IACpC,2CAA2C;IAC3C,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,2CAA2C;IAC3C,cAAc;AAClB;;AAEA;;;IAGI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;;;IAGI,SAAS;IACT,eAAe;IACf,aAAa;AACjB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,4CAA4C;AAChD;;AAEA;IACI,SAAS;IACT,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,2BAA2B;IAC3B,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;IACI,6DAA6D;IAC7D,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,cAAc;AAClB;;AAEA,wBAAwB;AACxB;;;IAGI,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;;;IAGI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;;;IAGI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,yCAAyC;IACzC,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,8BAA8B;IAC9B,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;IACI,+FAA+F;IAC/F,mBAAmB;IACnB,aAAa;IACb,4CAA4C;IAC5C,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":["/* Connectivity Test Component Styles */\n\n.connectivity-test-container {\n    background: var(--card-bg);\n    backdrop-filter: var(--glass-blur);\n    border: var(--glass-border) !important;\n    border-radius: 32px;\n    padding: 3rem;\n    margin: 2rem 0;\n    box-shadow: var(--glass-shadow), var(--glass-inner-glow);\n}\n\n.connectivity-test-header {\n    text-align: center;\n    margin-bottom: 3.5rem;\n}\n\n.connectivity-test-header h3 {\n    font-size: 2.4rem;\n    font-weight: 600;\n    color: var(--text-main);\n    letter-spacing: -0.03em;\n    margin-bottom: 0.5rem;\n}\n\n.connectivity-test-header p {\n    font-size: 1.1rem;\n    color: var(--text-secondary);\n    font-weight: 500;\n}\n\n/* Visual Flow Diagram */\n.connectivity-flow {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 2.5rem;\n    margin: 4rem 0;\n    padding: 3rem;\n    background: rgba(15, 22, 42, 0.2);\n    border-radius: 28px;\n    border: var(--glass-border) !important;\n    box-shadow: inset 0 2px 10px rgba(0, 0, 0, 0.3);\n}\n\n.flow-node {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n    padding: 2.5rem;\n    background: var(--card-bg) !important;\n    backdrop-filter: var(--glass-blur);\n    border: var(--glass-border) !important;\n    border-radius: 24px;\n    min-width: 180px;\n    position: relative;\n    transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);\n    box-shadow: var(--glass-shadow), var(--glass-inner-glow);\n}\n\n.flow-node:hover {\n    transform: translateY(-6px) scale(1.025);\n    box-shadow: 0 16px 36px rgba(99, 102, 241, 0.15), var(--glass-shadow);\n    border-color: rgba(99, 102, 241, 0.3) !important;\n}\n\n.flow-node.active {\n    transform: scale(1.05);\n    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);\n    animation: pulse 2s infinite;\n}\n\n.flow-node.success {\n    border: 3px solid #10b981;\n}\n\n.flow-node.error {\n    border: 3px solid #ef4444;\n}\n\n@keyframes pulse {\n\n    0%,\n    100% {\n        box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);\n    }\n\n    50% {\n        box-shadow: 0 8px 32px rgba(102, 126, 234, 0.6);\n    }\n}\n\n.flow-node .node-icon {\n    font-size: 48px;\n    margin-bottom: 8px;\n}\n\n.flow-node .node-label {\n    font-size: 14px;\n    font-weight: 600;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.flow-node .node-name {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--text-primary);\n    text-align: center;\n}\n\n.flow-node .node-status {\n    position: absolute;\n    top: -12px;\n    right: -12px;\n    font-size: 32px;\n    background: var(--bg-button-secondary);\n    border: var(--glass-border);\n    border-radius: 50%;\n    width: 48px;\n    height: 48px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: var(--glass-shadow);\n}\n\n.flow-arrow {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    color: rgba(255, 255, 255, 0.8);\n}\n\n.arrow-line {\n    width: 60px;\n    height: 3px;\n    background: rgba(255, 255, 255, 0.6);\n    border-radius: 2px;\n}\n\n.arrow-head {\n    font-size: 32px;\n    font-weight: bold;\n}\n\n/* Test Action */\n.test-action {\n    text-align: center;\n    margin: 24px 0;\n}\n\n.btn-test-connectivity {\n    background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n    color: white;\n    border: none;\n    padding: 16px 48px;\n    border-radius: 16px;\n    font-size: 1.1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n    box-shadow: 0 10px 30px rgba(16, 185, 129, 0.3), var(--glass-inner-glow);\n}\n\n.btn-test-connectivity:hover:not(:disabled) {\n    transform: translateY(-3px) scale(1.02);\n    box-shadow: 0 20px 45px rgba(16, 185, 129, 0.45), var(--glass-inner-glow);\n}\n\n.btn-test-connectivity:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* Test Results */\n.test-results-container {\n    margin-top: 32px;\n    background: var(--surface-light);\n    border-radius: 12px;\n    padding: 32px;\n}\n\n.overall-success,\n.overall-error,\n.overall-warning {\n    text-align: center;\n    padding: 32px;\n    border-radius: 16px;\n    margin-bottom: 24px;\n    box-shadow: var(--glass-shadow), var(--glass-inner-glow);\n    backdrop-filter: var(--glass-blur);\n}\n\n.overall-success {\n    background: rgba(16, 185, 129, 0.06);\n    border: 1.5px solid rgba(16, 185, 129, 0.3);\n    color: #10b981;\n}\n\n.overall-error {\n    background: rgba(239, 68, 68, 0.06);\n    border: 1.5px solid rgba(239, 68, 68, 0.3);\n    color: #ef4444;\n}\n\n.overall-warning {\n    background: rgba(245, 158, 11, 0.06);\n    border: 1.5px solid rgba(245, 158, 11, 0.3);\n    color: #f59e0b;\n}\n\n.success-icon,\n.error-icon,\n.warning-icon {\n    font-size: 64px;\n    margin-bottom: 16px;\n}\n\n.overall-success h3 {\n    color: #10b981;\n    margin: 0 0 8px 0;\n}\n\n.overall-error h3 {\n    color: #ef4444;\n    margin: 0 0 8px 0;\n}\n\n.overall-warning h3 {\n    color: #f59e0b;\n    margin: 0 0 8px 0;\n}\n\n.overall-success p,\n.overall-error p,\n.overall-warning p {\n    margin: 0;\n    font-size: 16px;\n    opacity: 0.95;\n}\n\n/* Connection Test Details */\n.detailed-results {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.connection-test-details {\n    background: var(--card-bg);\n    border-radius: 12px;\n    padding: 24px;\n    border: 1px solid var(--card-border);\n}\n\n.test-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    padding-bottom: 16px;\n    border-bottom: 2px solid var(--border-color);\n}\n\n.test-header h4 {\n    margin: 0;\n    font-size: 20px;\n    color: var(--text-primary);\n}\n\n.connection-name {\n    font-size: 14px;\n    color: var(--text-muted);\n    font-weight: 600;\n}\n\n.detail-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 16px;\n    margin-bottom: 16px;\n}\n\n.detail-item {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.detail-item.full-width {\n    grid-column: 1 / -1;\n}\n\n.detail-label {\n    font-size: 13px;\n    color: #64748b;\n    font-weight: 600;\n}\n\n.detail-value {\n    font-size: 16px;\n    color: var(--text-secondary);\n    font-weight: 500;\n}\n\n.latency-value {\n    font-size: 20px;\n}\n\n.version-text {\n    font-size: 14px;\n    font-family: 'Courier New', monospace;\n    background: var(--bg-input);\n    color: var(--text-primary);\n    padding: 8px 12px;\n    border-radius: 6px;\n    border: var(--glass-border);\n}\n\n/* Capabilities */\n.capabilities-section {\n    margin-top: 16px;\n    padding-top: 16px;\n    border-top: 1px solid var(--border-color);\n}\n\n.capabilities-section h5 {\n    margin: 0 0 12px 0;\n    font-size: 16px;\n    color: #1e293b;\n}\n\n.capability-badges {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.capability-badge {\n    padding: 6px 14px;\n    border-radius: 20px;\n    font-size: 13px;\n    font-weight: 600;\n    background: var(--surface-light);\n    color: var(--text-secondary);\n}\n\n.capability-badge.cdc-supported {\n    background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);\n    color: #1e40af;\n}\n\n.capability-badge.cdc-ready {\n    background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n    color: #065f46;\n}\n\n.capability-badge.can-write {\n    background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%);\n    color: #9f1239;\n}\n\n/* Warnings and Errors */\n.warnings-section,\n.errors-section,\n.suggestions-section {\n    margin-top: 16px;\n    padding-top: 16px;\n    border-top: 1px solid var(--border-color);\n}\n\n.warnings-section h5,\n.errors-section h5,\n.suggestions-section h5 {\n    margin: 0 0 12px 0;\n    font-size: 16px;\n    color: #1e293b;\n}\n\n.warning-item,\n.error-item,\n.suggestion-item {\n    padding: 12px 16px;\n    border-radius: 8px;\n    margin-bottom: 8px;\n    font-size: 14px;\n    line-height: 1.6;\n}\n\n.warning-item {\n    background: rgba(245, 158, 11, 0.05);\n    border: 1px solid rgba(245, 158, 11, 0.15);\n    border-left: 4px solid #f59e0b;\n    color: #f59e0b;\n}\n\n.error-item {\n    background: rgba(239, 68, 68, 0.05);\n    border: 1px solid rgba(239, 68, 68, 0.15);\n    border-left: 4px solid #ef4444;\n    color: #ef4444;\n}\n\n.suggestion-item {\n    background: rgba(59, 130, 246, 0.05);\n    border: 1px solid rgba(59, 130, 246, 0.15);\n    border-left: 4px solid #3b82f6;\n    color: #3b82f6;\n}\n\n/* Bridge Recommendations */\n.bridge-recommendations {\n    background: linear-gradient(135deg, rgba(139, 92, 246, 0.08) 0%, rgba(99, 102, 241, 0.08) 100%);\n    border-radius: 12px;\n    padding: 24px;\n    border: 1.5px solid rgba(139, 92, 246, 0.25);\n    box-shadow: var(--glass-shadow);\n}\n\n.bridge-recommendations h4 {\n    margin: 0 0 16px 0;\n    font-size: 18px;\n    color: var(--text-accent);\n}\n\n.recommendation-item {\n    padding: 12px 16px;\n    background: var(--card-bg);\n    border: var(--glass-border);\n    border-radius: 8px;\n    margin-bottom: 8px;\n    font-size: 14px;\n    line-height: 1.6;\n    color: var(--text-primary);\n    border-left: 4px solid #8b5cf6;\n}\n\n.recommendation-item:last-child {\n    margin-bottom: 0;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .connectivity-flow {\n        flex-direction: column;\n        gap: 16px;\n    }\n\n    .flow-arrow {\n        transform: rotate(90deg);\n    }\n\n    .flow-node {\n        width: 100%;\n        max-width: 300px;\n    }\n\n    .detail-grid {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
